module.exports = __webpack_public_path__ + "img/Monte_Kope_88.f231e20d.jpg";